import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { LobByOid } from '../../services/Ebootis.Queries/LobByOid';
import { ConfigurationService } from '../configuration-select/configuration.service';

@Component({
	selector: 'app-imprint',
	templateUrl: './imprint.component.html',
	styleUrls: ['./imprint.component.scss'],
})
export class ImprintComponent implements OnInit, OnDestroy {

	private m_subscriptionsSubject = new Subject();
	public m_htmlData: SafeHtml;

	constructor(
		public m_configurationService: ConfigurationService,
		private m_lobByOid: LobByOid,
		private m_sanitizer: DomSanitizer,
		public m_http: HttpClient,
		private m_router: Router,
	) { }

	/**
	 * Ruft die Methode für das Laden der KonfigurationsObjekte wird aufgerufen.
	 */
	public ngOnInit() {
		this.m_configurationService.getConfiguration()
			.pipe(take(1))
			.subscribe({
				next: (cfg) => {
					if (cfg?.imprint)
						this.setCustomImpressPage(cfg?.imprint.oid);
					else
						this.m_router.navigate(['/uebersicht']);

				}
			})
	}

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Der Inhalt des Konfigurations Objektes wird geladen.
	 * @param p_configObjectOid OID des Konfigurations Objektes
	 */
	public setCustomImpressPage(p_configObjectOid: string): void {
		this.m_http.get(this.m_lobByOid.getLobUrl({ lob: p_configObjectOid }), { responseType: 'text' }).pipe(
			takeUntil(this.m_subscriptionsSubject),
		).subscribe({
			next: (result) => {
				this.m_htmlData = this.m_sanitizer.bypassSecurityTrustHtml(result);
			},
		});
	}

}
